import './App.css';
import { Environment } from './components/Environment';
import { Devices } from './components/Devices';
import { Login } from './components/Login';
import { Route, Routes } from 'react-router-dom';
import { Farms } from './components/Farms';
import { Payment } from './components/Payment';
import { ListAllEnvs } from './components/ListAllEnvs';
import { SystemStatus } from './components/SystemStatus';
import { UserManagement } from './components/UserManagement';
import { Enquiry } from './components/Enquiry';
import { PhySenseConfig } from './components/PhySenseConfig';

function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/environment' element={<Environment />} />
        <Route path='/devices' element={<Devices />} />
        <Route path='/farms' element={<Farms />} />
        <Route path="/payments" element={<Payment />} />
        <Route path="/listenvs" element={<ListAllEnvs />} />
        <Route path="/userManagement" element={<UserManagement />} />
        <Route path="/phySenseConfig" element={<PhySenseConfig />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/SystemStatus" element={<SystemStatus />} />
      </Routes>
    </>
  );
}

export default App;
